import React from "react";
import { SearchThisAreaButton } from "./SearchThisAreaButton";

interface SearchThisAreaDesktopProps {
  isSmallScreen: boolean;
  popupContainerRef: React.MutableRefObject<HTMLDivElement | null>;
  map: React.MutableRefObject<mapboxgl.Map | null>;
  updateMapWithSearchResults: () => {};
}

const SearchThisAreaDesktop: React.FC<SearchThisAreaDesktopProps> = ({
  map,
}) => {
  return (
    <>
      {/* //$ set up 'search this area' button for md+ */}
      {map.current && (
        <SearchThisAreaButton
          onButtonPress={async () => {
            try {
              if (!map?.current) return;
              const center = map.current.getCenter();
              const zoomLevel = map.current.getZoom();
              let newViewport: any = {
                lng: parseFloat(center.lng.toFixed(4)),
                lat: parseFloat(center.lat.toFixed(4)),
                zoom: parseFloat(zoomLevel.toFixed(2)),
              };

              const bounds = map.current.getBounds();

              if (bounds) {
                const southWest = bounds.getSouthWest();
                const northEast = bounds.getNorthEast();

                newViewport = {
                  ...newViewport,
                  minLat: southWest.lat,
                  minLng: southWest.lng,
                  maxLat: northEast.lat,
                  maxLng: northEast.lng,
                };
              }

              // @ts-ignore
              window.flutter_inappwebview.callHandler(
                "fromWebApp",
                "trigger_new_search: " + JSON.stringify(newViewport)
              );
            } catch (e) {}
          }}
          isSmallScreen={false}
        />
      )}
    </>
  );
};

export default SearchThisAreaDesktop;
